import HeroCarousel from "@/pages/home/components/HeroCarousel";
import WorksHighlight from "@/pages/home/components/WorksHighlight";
import NewsLatest from "@/pages/home/components/NewsLatest";
import StarSection from "@/pages/home/components/StarSection";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { works } from "@/mocks/works";
import { news } from "@/mocks/news";

const stats = [
  { value: works.length, suffix: "+", label: "影视作品收录" },
  { value: news.length, suffix: "+", label: "动态资讯更新" },
  { value: 13, suffix: "年", label: "作品持续输出" },
  { value: 100, suffix: "%", label: "作品资料整理" },
];

export default function Home() {
  useDocumentTitle(
    "杨幂影视作品与最新动态 - 明星资讯平台",
    "杨幂明星资讯平台全面提供杨幂的电视剧、电影作品介绍与最新动态，覆盖粉丝关注的明星新闻和活动信息。",
    "杨幂,杨幂影视,杨幂动态,明星资讯,影视作品,影视明星,最新消息,杨幂新闻",
  );

  return (
    <div className="w-full">
      <HeroCarousel />

      <section className="w-full px-4 md:px-8 -mt-8 relative z-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
                {s.value}
                <span className="text-base md:text-lg">{s.suffix}</span>
              </p>
              <p className="mt-1 text-xs md:text-sm text-foreground-500 font-label">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <WorksHighlight />
      <NewsLatest />
      <StarSection />
    </div>
  );
}